module.exports = __webpack_public_path__ + "static/img/Inspection22.f5f18f6e.jpg";